import { Text } from "@chakra-ui/react";
import { ChevronRightIcon } from "@chakra-ui/icons";
import { APP_NAME } from "runtime-config/config";
import BrandName from "components/Brands/BrandName";
import LinkButton from "components/UI/Links/LinkButton";
import ErrorPage from "components/Layout/ErrorPage";
import { useRouter } from "next/router";
import { createContext, ReactNode } from "react";
import { BRAND_BILLING } from "lib/routing/links";
import useHomePageRedirect from "./useHomePageRedirect";

export function useIsSubscriptionRequired() {
  const router = useRouter();

  if (router.pathname.startsWith("/settings")) return false;

  return true;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SubscriptionRequiredContext =
  createContext<ReturnType<typeof useIsSubscriptionRequired>>(false);

type SubscriptionRequiredProviderProps = {
  children: ReactNode;
};

export function SubscriptionRequiredProvider({
  children,
}: SubscriptionRequiredProviderProps) {
  const isSubscriptionRequired = useIsSubscriptionRequired();
  return (
    <SubscriptionRequiredContext.Provider value={isSubscriptionRequired}>
      {children}
    </SubscriptionRequiredContext.Provider>
  );
}

export default function InvalidSubscription() {
  useHomePageRedirect();
  return (
    <ErrorPage heading="Subscribe for Access">
      <Text fontSize="1.25em" my={10}>
        The {APP_NAME} subscription for <BrandName /> has ended. To continue
        using {APP_NAME}, please purchase a new subscription.
      </Text>

      <LinkButton
        href={BRAND_BILLING}
        colorScheme="pinkButton"
        whiteSpace="normal"
        rightIcon={<ChevronRightIcon />}
      >
        Manage Subscription Details
      </LinkButton>
    </ErrorPage>
  );
}
